/**
 * QW1 — o tempo verbal da navegação.
 *
 * O envelope `navegacao` produz UMA frase na conversa, e ela precisa dizer o
 * que de fato aconteceu. Em `modo_de_abertura: painel` a tela real já abriu
 * pelo router quando a bolha aparece: pedir permissão ali ("posso te
 * levar para X") faz a pessoa achar que ainda falta um passo que já foi dado —
 * é o speech act errado, e mina a leitura do que o agente fez (R3).
 *
 * Em `handoff` nada abriu: a bolha oferece um botão, e a frase tem de
 * continuar sendo oferta. Por isso são duas chaves, e não uma frase só.
 *
 * A decisão é uma escolha de CHAVE, não de texto: quem traduz é o chamador,
 * que também é quem conhece o `rotulo`.
 */

/** A tela real já está aberta quando a bolha aparece. */
export const CHAVE_NAVEGACAO_ABERTA = 'assistentePontotel.conversa.navegacaoAberta'

/**
 * A tela abriu E tem nome publicado: a frase nomeia a TELA em vez de repetir o
 * rótulo do botão. O `rotulo` é copy imperativa ("Abrir calendário de
 * feriados") — na oferta ela está certa, mas no passado vira "Abri Abrir
 * calendário de feriados ao lado.", que foi o achado 5.3.
 */
export const CHAVE_NAVEGACAO_ABERTA_COM_TELA = 'assistentePontotel.conversa.navegacaoAbertaTela'

/** Nada abriu: o canvas oferece o caminho, a frase oferece junto. */
export const CHAVE_NAVEGACAO_OFERTA = 'assistentePontotel.conversa.navegacao'

/**
 * `modo_de_abertura` chega normalizado em `'painel' | 'handoff'`, mas aceita
 * `string | null` porque a origem é a wire e um modo desconhecido não pode
 * virar afirmação de que a tela abriu.
 *
 * `nomeiaATela` é o segundo eixo: com a tela já aberta E nome publicado, a
 * frase nomeia a tela; sem nome, ela cai no rótulo. Quem sabe se há nome é o
 * chamador — é ele que resolve a rota —, e é ele que monta o parâmetro
 * correspondente (`{ tela }` ou `{ rotulo }`).
 */
export function chaveDoTextoDeNavegacao (
  modoDeAbertura?: string | null,
  nomeiaATela = false
): string {
  if (modoDeAbertura !== 'painel') return CHAVE_NAVEGACAO_OFERTA
  return nomeiaATela ? CHAVE_NAVEGACAO_ABERTA_COM_TELA : CHAVE_NAVEGACAO_ABERTA
}
